import { render } from "./ColorFilters.vue?vue&type=template&id=13282a72"
import script from "./ColorFilters.vue?vue&type=script&lang=js"
export * from "./ColorFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__